import { useParams } from "react-router-dom";
import { SiteHeader } from "../platform/PlatformChrome";
import { Footer } from "../landing/Footer";
import { EventView } from "./EventView";

/**
 * Page-version event detail. Used for direct visits, refreshes, and
 * shared-URL pastes — when there's no `backgroundLocation` in router state.
 *
 * Public surface wraps in <SiteHeader /> and <Footer/>; dashboard surface relies on
 * DashboardLayout's outlet to provide the surrounding chrome.
 */

interface EventPageProps {
  surface: "public" | "dashboard";
}

export function EventPage({ surface }: EventPageProps) {
  const { slug } = useParams<{ slug: string }>();

  if (!slug) {
    return (
      <main className="container-edit pt-32 pb-20">
        <p className="font-display-italic text-[var(--color-ink-mute)]">No event specified.</p>
      </main>
    );
  }

  if (surface === "public") {
    return (
      <>
        <SiteHeader />
        <main className="pt-32 pb-24">
          <div className="container-edit max-w-[820px]">
            <EventView
              slug={slug}
              mode="page"
              basePath="/calendar"
              newsBasePath="/news"
            />
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <div className="container-edit max-w-[920px]">
      <EventView
        slug={slug}
        mode="page"
        basePath="/dashboard/calendar"
        newsBasePath="/dashboard/articles"
      />
    </div>
  );
}
